import type { LeadsSearchRow } from "app/pages/sales-intelligence/modules/leads-search";

import { ExportType } from "./store/type";

export const ACCOUNTS_MANDATORY_FIELDS: ReadonlyArray<keyof LeadsSearchRow> = ["site", "company_name"];

export const CONTACTS_MANDATORY_FIELDS: ReadonlyArray<string> = ["email", "first_name", "last_name"];

export const ACCOUNTS_AND_CONTACTS_MANDATORY_FIELDS: ReadonlyArray<string> = [
    ...ACCOUNTS_MANDATORY_FIELDS,
    ...CONTACTS_MANDATORY_FIELDS,
];
export const CONTACTS_ENRICHMENT_MANDATORY_FIELDS: ReadonlyArray<keyof LeadsSearchRow> = ["site"];

export const exportTypes = [ExportType.accounts, ExportType.contacts, ExportType.leads, ExportType.companyAsLeads];
export const exportTypeToRecordName = {
    [ExportType.accounts]: "accounts",
    [ExportType.contacts]: "contacts",
    [ExportType.leads]: "leads",
    [ExportType.companyAsLeads]: "companyAsLeads",
} as const;

export const CONTACTS_CRM_EXPORT_LIMIT = 100;
